export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'Container', 
              name: "Container Suporte",
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsSupport1', 
                },
                
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};